'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.servers = exports.validations = undefined;

var _validations = require('./validations');

var _validations2 = _interopRequireDefault(_validations);

var _servers = require('./servers');

var _servers2 = _interopRequireDefault(_servers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.validations = _validations2.default;
exports.servers = _servers2.default;


//////////////////
// WEBPACK FOOTER
// ./~/common/dist/index.js
// module id = 95
// module chunks = 0